import { render, staticRenderFns } from "./ImpersonationBanner.vue?vue&type=template&id=609d1d25&scoped=true"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=ts"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=ts"
import style0 from "./ImpersonationBanner.vue?vue&type=style&index=0&id=609d1d25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d1d25",
  null
  
)

export default component.exports